<template>
    <div>
      <Transfer_goods_received/>
    </div>
  </template>
  
  <script>
  import Transfer_goods_received from "@/components/adminArin/pos_system/warehouse/warehouse_all/Transfer_goods_received";
  export default {
    name: "Transfergoodsreceived",
    components: {
      Transfer_goods_received
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  